
export default {
  props: {
    suggestion: {type: Object, required: true},
    selected: {type: Boolean, default: false},
    checkIcon: {type: Boolean, default: false},
  },
  computed: {
    name(){
      return this.suggestion.display_name || this.suggestion.name
    },
    link() {
      if (this.suggestion.shared_company_id) return this.suggestion.website_url
      
      if (this.suggestion.website_url) {
        return this.suggestion.website_url
      } 
      
      if (this.suggestion.linkedin_id) {
        return `linkedin: ${this.suggestion.linkedin_id}`
      }

      return undefined
    }
  },
}
